import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Icon,
} from "@elaniintc/goes-design-system";
import type { AnnouncementType } from "@/types/entities/announcements";
import { useAuthorization } from "@/hooks/use-authorization";
import { Permissions } from "@/utils/permissions";

export const Menu = ({
  notification,
  onEdit,
  onToggleStatus,
  onDelete,
}: {
  notification: AnnouncementType;
  onEdit: (notification: AnnouncementType) => void;
  onToggleStatus: (notification: AnnouncementType) => void;
  onDelete: (notification: AnnouncementType) => void;
}) => {
  const { hasPermission } = useAuthorization();
  const canEdit = hasPermission(Permissions.announcements.update);
  const canDelete = hasPermission(Permissions.announcements.delete);

  if (!canEdit && !canDelete) return null;

  const isPublished = notification.status === "published";
  const isArchived = notification.status === "archived";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="xs" className="size-8">
          <Icon
            type="far"
            name="ellipsis-vertical"
            className="text-current text-sm"
          />
          <span className="sr-only">Acciones para notificación</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="w-55.5 min-w-56 rounded-lg border-neutral-silent text-body font-normal p-2"
        side="bottom"
        align="end"
        sideOffset={4}
      >
        <DropdownMenuGroup>
          {/* Opción de editar - siempre disponible */}
          {canEdit && (
            <DropdownMenuItem
              className="hover:bg-neutral-object-accent-silent py-2 px-3 cursor-pointer"
              onClick={() => onEdit(notification)}
            >
              Editar notificación
            </DropdownMenuItem>
          )}

          {isArchived && (
            <DropdownMenuItem
              className="py-2 px-3 text-body-quiet cursor-not-allowed opacity-50"
              disabled
            >
              Despublicar notificación
            </DropdownMenuItem>
          )}

          {!isArchived && (
            <>
              {isPublished && (
                <DropdownMenuItem
                  className="hover:bg-neutral-object-accent-silent py-2 px-3 cursor-pointer"
                  onClick={() => onToggleStatus(notification)}
                >
                  Despublicar notificación
                </DropdownMenuItem>
              )}
              {!isPublished && (
                <DropdownMenuItem
                  className="hover:bg-neutral-object-accent-silent py-2 px-3 cursor-pointer"
                  onClick={() => onToggleStatus(notification)}
                >
                  Publicar notificación
                </DropdownMenuItem>
              )}
            </>
          )}

          {/* La opción de eliminar siempre está disponible */}
          {canDelete && (
            <DropdownMenuItem
              className="hover:bg-neutral-object-accent-silent py-2 px-3 text-danger cursor-pointer"
              onClick={() => onDelete(notification)}
            >
              Eliminar notificación
            </DropdownMenuItem>
          )}
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
